import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/system';

// 送出首頁變更大類代號
export function initTransaction(aplCatl) {
    return post(`${url}/initTransaction`, { aplCatl });
}

// 保單總覽
export function policyOverview(type) {
    return get(`${url}/policyOverview?type=${type}`);
}

// 送出選擇的保單
export function selectChangedPolicy(data) {
    return post(`${url}/selectChangedPolicy`, data, { ...options, repeatRequestCancel: true });
}

// 取得保單可進行的變更項目
export function getTransactionItems() {
    return get(`${url}/transactionItems`);
}

// 送出選擇的變更項目 可以傳一個新增/或是一組進行排列
export function postTransactionItems(data) {
    return post(`${url}/transactionItems`, { transactionItemNos: data });
}

// 6.取得保戶留存於公司的行動電話及電子信箱
export function getContactInfo() {
    return get(`${url}/contactInfo`, undefined, { ...options, closeAlert: true });
}
// 6-1.更新OTP行動電話及電子信箱，非631、640、借款的交易項目使用
export function submitContact(data) {
    return post(`${url}/submitContact`, data, { ...options, repeatRequestCancel: true });
}

// 取得行動電話國碼下拉選單
export function getMobileCodeInfo() {
    return get(`${url}/mobileCodeInfo`);
}

// 開始進行線上交易變更
export function startTransaction() {
    return post(`${url}/startTransaction`);
}

// 確認本次所有變更內容，並同意/不同意通知服務人員
export function confirmTransaction(isAgree) {
    return post(`${url}/confirm`, { agreeNoticeAgent: isAgree });
}

// 放棄所有變更項目
export function cancelTransaction() {
    return post(`${url}/cancelTransaction`, null, { ...options, errorDialog: false });
}

// 取消指定的變更項目
export function cancelTransactionItem(code) {
    return post(`${url}/cancelTransactionItem`, { transactionItemNo: code }, { ...options, repeatRequestCancel: true });
}

// 可否返回修改交易變更項目
export function editTransactionItem(code) {
    return post(`${url}/editTransactionItem`, { transactionItemNo: code }, { ...options, repeatRequestCancel: true });
}

// 所有變更項目在變更資料內容（資料確認）
export function getResult() {
    return get(`${url}/transactionResult`);
}

// OTP驗證成功後，完成交易變更
export function getCompleteData() {
    return post(`${url}/completeTransaction`, null, { ...options, errorDialog: true });
}

// SCV A3~A5 登入後，初始化交易變更項目
export function ssoInitExternalTransaction(data) {
    return post(`${url}/ssoInitExternalTransaction`, data);
}

// 給付約定非有效件，初始化交易變更項目
export function ssoPayAccInitExternalTransaction(data) {
    return post(`${url}/ssoPayAccInitExternalTransaction`, data);
}

// 8.檢核是否需新增交易項目，checkTransactionList.length === 0，才進行高風險預告書
export function checkTransaction() {
    return get(`${url}/checkTransaction`);
}

// 8-1.檢核是否需高風險預告書檢核(投資型保單需檢核) isRisk=true, 再進行8-2 & 8-3
export function getIsBenefitRisk() {
    return get(`${url}/isBenefitRisk`);
}

// 8-2.取得高收益債券基金風險預告書
export function getBenefitRiskInfo() {
    return get(`${url}/benefitRiskInfo`);
}

// 8-3.同意高收益債券基金風險預告書
export function postAgreeBenefitRisk() {
    return post(`${url}/agreeBenefitRisk`);
}

// 取消交易變更項目前提示訊息
export function beforeCancelTransactionItem(code) {
    return post(`${url}/beforeCancelTransactionItem`, { transactionItemNo: code });
}
